(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5899],{

/***/ 33885:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chef/[chef-dynamic-url]",
      function () {
        return __webpack_require__(36252);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98396);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var _components_innerLayout_InnerLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66570);
/* harmony import */ var _components_Loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43369);
/* harmony import */ var _components_public_profile_DesktopView__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55081);
/* harmony import */ var _components_public_profile_MobileView__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88437);
/* harmony import */ var _constants_tabs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28141);
/* harmony import */ var _redux_createSidebarSlice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18129);
/* harmony import */ var _redux_createTabSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89515);



// <--- Import Head



// import { toast } from "react-toastify"; // Not used in this snippet, remove if not needed elsewhere







var ProfilePublic = function(param) {
    var userData = param.userData, imageData = param.imageData, chefDynamicUrl = param.chefDynamicUrl;
    var ref, ref1, ref2, ref3, ref4;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var isMdSize = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("(min-width:900px)");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        dispatch((0,_redux_createSidebarSlice__WEBPACK_IMPORTED_MODULE_10__/* .setSelectedSidebarUser */ .My)(userData !== null && userData !== void 0 ? userData : null));
        dispatch((0,_redux_createTabSlice__WEBPACK_IMPORTED_MODULE_11__/* .setTab */ .IE)(_constants_tabs__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Search */ .Z.Search));
        return function() {
            dispatch((0,_redux_createSidebarSlice__WEBPACK_IMPORTED_MODULE_10__/* .setSelectedSidebarUser */ .My)(null));
        };
    }, [
        dispatch,
        userData
    ]);
    if (!userData) {
        // This case should ideally be fully handled by getStaticProps returning notFound: true
        // If it still occurs, it's a loader state or an unexpected issue.
        console.error("ProfilePublic: Rendered without userData.");
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                            children: "Profile Not Found"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "robots",
                            content: "noindex"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            ]
        });
    }
    // --- Prepare Meta Tag Content ---
    var chefName = userData.publicName || "".concat(userData.firstName || "", " ").concat(userData.lastName || "").trim();
    // Location string for title
    var locationStr = ((ref = userData.address) === null || ref === void 0 ? void 0 : ref.locality) ? " in ".concat(userData.address.locality).concat(userData.address.state ? ", ".concat(userData.address.state) : "") : "";
    // Service types for value proposition
    var primaryService = ((ref1 = userData.chefServices) === null || ref1 === void 0 ? void 0 : ref1[0]) || "Private Chef";
    var isTopRated = userData.rating && userData.rating >= 4.5;
    var ratingText = isTopRated ? "Top-Rated " : "";
    // Action-oriented, compelling title
    var pageTitle = "Hire ".concat(chefName, " - ").concat(ratingText).concat(primaryService).concat(locationStr, " | MorePleaze");
    // Compelling meta description with benefits and call-to-action
    var metaDescription = userData.bio && userData.bio.length > 20 ? "Hire ".concat(chefName, ", ").concat(ratingText.toLowerCase(), "professional chef").concat(locationStr, ". ").concat(userData.bio.substring(0, 100), "... Book your culinary experience today on MorePleaze!") : "Hire ".concat(chefName, ", ").concat(ratingText.toLowerCase(), "professional chef").concat(locationStr, ". ").concat(userData.hourlyRate ? "Starting at $".concat(userData.hourlyRate, "/hour. ") : "", "Book personalized dining experiences, cooking classes & private catering. Available on MorePleaze!");
    var profileImageUrl = userData.profileImage || "/default-profile-image.png"; // Provide a fallback image
    var canonicalUrl = "".concat("https://app.morepleaze.com", "/chef/").concat(chefDynamicUrl); // Set NEXT_PUBLIC_BASE_URL in .env
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: pageTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "profile"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: pageTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "MorePleaze"
                    }),
                    profileImageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: profileImageUrl
                    }),
                    profileImageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:alt",
                        content: "".concat(chefName, " - Professional Chef")
                    }),
                    userData.hourlyRate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:price:amount",
                        content: userData.hourlyRate
                    }),
                    userData.hourlyRate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:price:currency",
                        content: "USD"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:title",
                        content: pageTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:description",
                        content: metaDescription
                    }),
                    profileImageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:image",
                        content: profileImageUrl
                    }),
                    profileImageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:image:alt",
                        content: "".concat(chefName, " - Professional Chef Profile")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:creator",
                        content: "@MorePleaze"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:site",
                        content: "@MorePleaze"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "hire chef, ".concat(chefName, ", private chef").concat(locationStr.replace(" in ", " "), ", ").concat(primaryService.toLowerCase(), ", personal chef, cooking classes, catering, MorePleaze").concat(userData.chefServices ? ", ".concat(userData.chefServices.join(", ").toLowerCase()) : "")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: chefName
                    }),
                    isTopRated && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "rating",
                        content: (ref2 = userData.rating) === null || ref2 === void 0 ? void 0 : ref2.toString()
                    }),
                    userData.hourlyRate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "price",
                        content: "$".concat(userData.hourlyRate, "/hour")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "availability",
                        content: "Available for booking"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "service-area",
                        content: ((ref3 = userData.address) === null || ref3 === void 0 ? void 0 : ref3.locality) || "Multiple locations"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "Person",
                                name: chefName,
                                image: profileImageUrl,
                                description: metaDescription,
                                url: canonicalUrl,
                                jobTitle: primaryService,
                                alternateName: userData.publicName ? [
                                    userData.publicName,
                                    "".concat(userData.firstName, " ").concat(userData.lastName), 
                                ].filter(Boolean) : undefined,
                                worksFor: {
                                    "@type": "Organization",
                                    name: "MorePleaze",
                                    url: "https://app.morepleaze.com"
                                },
                                hasOccupation: {
                                    "@type": "Occupation",
                                    name: primaryService,
                                    description: "Professional ".concat(primaryService.toLowerCase(), " offering personalized culinary experiences")
                                },
                                address: userData.address ? {
                                    "@type": "PostalAddress",
                                    addressLocality: userData.address.locality || "",
                                    postalCode: userData.address.postalCode || "",
                                    addressRegion: userData.address.state || "",
                                    addressCountry: userData.address.country || "US"
                                } : undefined,
                                aggregateRating: userData.rating ? {
                                    "@type": "AggregateRating",
                                    ratingValue: userData.rating,
                                    ratingCount: userData.ratingCount || 1
                                } : undefined,
                                knowsAbout: userData.chefServices || [],
                                priceRange: userData.hourlyRate ? "$".concat(userData.hourlyRate, "/hour") : undefined,
                                hasOfferCatalog: {
                                    "@type": "OfferCatalog",
                                    name: "Culinary Services",
                                    itemListElement: ((ref4 = userData.chefServices) === null || ref4 === void 0 ? void 0 : ref4.map(function(service) {
                                        return {
                                            "@type": "Offer",
                                            itemOffered: {
                                                "@type": "Service",
                                                name: service,
                                                description: "Professional ".concat(service.toLowerCase(), " services by ").concat(chefName)
                                            },
                                            priceSpecification: userData.hourlyRate ? {
                                                "@type": "PriceSpecification",
                                                price: userData.hourlyRate,
                                                priceCurrency: "USD",
                                                unitText: "hour"
                                            } : undefined
                                        };
                                    })) || [
                                        {
                                            "@type": "Offer",
                                            itemOffered: {
                                                "@type": "Service",
                                                name: "Private Chef Services",
                                                description: "Professional private chef services by ".concat(chefName)
                                            }
                                        }, 
                                    ]
                                },
                                makesOffer: userData.hourlyRate ? {
                                    "@type": "Offer",
                                    name: "".concat(primaryService, " Services"),
                                    description: "Hire ".concat(chefName, " for personalized culinary experiences"),
                                    priceSpecification: {
                                        "@type": "PriceSpecification",
                                        price: userData.hourlyRate,
                                        priceCurrency: "USD",
                                        unitText: "hour"
                                    },
                                    availability: "https://schema.org/InStock",
                                    validFrom: new Date().toISOString()
                                } : undefined,
                                sameAs: [
                                    userData.instagram,
                                    userData.facebook,
                                    userData.linkedIn,
                                    userData.website, 
                                ].filter(Boolean)
                            })
                        }
                    })
                ]
            }),
            isMdSize ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_public_profile_DesktopView__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                userData: userData,
                imageData: imageData || undefined
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_public_profile_MobileView__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                userData: userData,
                imageData: imageData || []
            })
        ]
    });
};
ProfilePublic.getLayout = function getLayout(component) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_innerLayout_InnerLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: component
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ProfilePublic);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4838,1255,8809,9066,89,9912,1440,6570,6746,5839,3090,9774,2888,179], function() { return __webpack_exec__(33885); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);